import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '../../components/ui/dialog';
import AuthFirstSalesPage from './AuthFirstSalesPage';
import './AuthDialogChrome.css';

type AuthFirstDialogProps = {
  analyticsContext?: Record<string, unknown>;
  authSourceOverride?: string;
  entryMode?: 'discovery' | 'checkout' | 'login' | 'signup';
  forceFreshLogin?: boolean;
  onAuthenticated?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  returnTo: string;
};

const AuthFirstDialog = ({
  analyticsContext,
  authSourceOverride,
  entryMode = 'discovery',
  forceFreshLogin = false,
  onAuthenticated,
  onOpenChange,
  open,
  returnTo,
}: AuthFirstDialogProps): React.ReactElement => {
  const contentRef = useRef<HTMLDivElement>(null);
  const title = entryMode === 'checkout'
    ? 'Create or sign in to continue to checkout'
    : entryMode === 'login'
      ? 'Sign in to BotSpot'
      : 'Create your BotSpot account';
  const description = entryMode === 'checkout'
    ? 'We’ll sign you in—or create an account. Your plan is saved.'
    : entryMode === 'login'
      ? 'Sign in—or create an account if you’re new.'
      : 'We’ll create an account—or sign you in if one exists.';

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className="auth-first-dialog-content"
        closeButtonClassName="auth-first-close-control"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          contentRef.current?.focus({ preventScroll: true });
        }}
        ref={contentRef}
        tabIndex={-1}
      >
        <DialogTitle className="bsui-sr-only">{title}</DialogTitle>
        <DialogDescription className="bsui-sr-only">{description}</DialogDescription>
        <AuthFirstSalesPage
          analyticsContext={analyticsContext}
          authSourceOverride={authSourceOverride}
          entryMode={entryMode}
          forceFreshLogin={forceFreshLogin}
          hideAuthHeaderFromAssistiveTech
          onAuthenticated={onAuthenticated}
          presentation="overlay"
          returnTo={returnTo}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AuthFirstDialog;
